var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FD911D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.351 3.34L1.347 14.343c-.056.056-.096.126-.115.201l-1.22 4.896c-.036.147.008.304.115.412.081.081.192.126.306.126.035 0 .07-.004.105-.013l4.895-1.22c.077-.019.146-.059.201-.114L16.64 7.628 12.35 3.339zM19.366 1.839L18.14.614c-.819-.819-2.246-.818-3.064 0l-1.5 1.5 4.288 4.289 1.5-1.501c.41-.409.635-.953.635-1.532 0-.578-.225-1.122-.634-1.531z",
    transform: "translate(-299.000000, -256.000000) translate(299.000000, 256.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6c2b08e78d29a1fe29f94312d8c79e93.svg";
export { ForwardRef as ReactComponent };